/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramAuthPhoneControllerAuthorizeByPhoneMutationRequest,
  TelegramAuthPhoneControllerAuthorizeByPhoneMutationResponse,
  TelegramAuthPhoneControllerAuthorizeByPhone401,
  TelegramAuthPhoneControllerAuthorizeByPhone403,
} from '../../types/TelegramAuthPhoneControllerAuthorizeByPhone.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramAuthPhoneAuthorizeByPhone } from '../../methods/telegramAuthPhoneAuthorizeByPhone.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramAuthPhoneAuthorizeByPhoneMutationKey = () => [{ url: '/api/telegram/auth/phone/login' }] as const;

export type TelegramAuthPhoneAuthorizeByPhoneMutationKey = ReturnType<
  typeof telegramAuthPhoneAuthorizeByPhoneMutationKey
>;

/**
 * {@link /api/telegram/auth/phone/login}
 */
export function useTelegramAuthPhoneAuthorizeByPhone<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramAuthPhoneControllerAuthorizeByPhoneMutationResponse,
      ResponseErrorConfig<
        TelegramAuthPhoneControllerAuthorizeByPhone401 | TelegramAuthPhoneControllerAuthorizeByPhone403
      >,
      { data: TelegramAuthPhoneControllerAuthorizeByPhoneMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramAuthPhoneControllerAuthorizeByPhoneMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramAuthPhoneAuthorizeByPhoneMutationKey();

  return useMutation<
    TelegramAuthPhoneControllerAuthorizeByPhoneMutationResponse,
    ResponseErrorConfig<
      TelegramAuthPhoneControllerAuthorizeByPhone401 | TelegramAuthPhoneControllerAuthorizeByPhone403
    >,
    { data: TelegramAuthPhoneControllerAuthorizeByPhoneMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramAuthPhoneAuthorizeByPhone(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
